module.exports = __webpack_public_path__ + "static/media/20ECE27.a386c8e3.jpg";